import { render, staticRenderFns } from "./FlagStatusList.vue?vue&type=template&id=54ab7ea5&"
import script from "./FlagStatusList.vue?vue&type=script&lang=js&"
export * from "./FlagStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports